import { render, staticRenderFns } from "./InputTipoDado.vue?vue&type=template&id=3ea8b40a&"
import script from "./InputTipoDado.vue?vue&type=script&lang=js&"
export * from "./InputTipoDado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports